import React, { useState } from 'react';
import { FiImage } from 'react-icons/fi';
import api from '../../../dataAccessLayer/firebase'

const AdvModalUpdate = props => {

	const {
		onHandleChangeFile,
		item,
		updateAdv,
		onVisiblePopup
		//imgUrl
	} = props;

	const [test, setTest] = useState({
		imgUrl: item.imgUrl,
		address: item.address,
		price: item.price,
		phone: item.phone,
		rooms: item.rooms,
		square: item.square,
		floor: item.floor,
		description: item.description,
		date: item.date,
		userId: item.userId
	})

	const onTestUpdate = e => {
		setTest({...test, [e.target.id]: e.target.value});
	};

	return (
			<div>
				<div className="modal__created-blur"></div>
				<div className="modal__created-modal">
					<div className="created__modal-header">
						<h2>Редактирование объявления</h2>
					</div>

					<div className="created__modal-body">
						<form className="body__form">
								<div className="modal__body-content">

									<div className="content">
										<h4>Фотографии</h4>
										<div className="content__body-photo-description">
											Не допускаются к размещению фотографии с водяными знаками, чужих объектов и
											рекламные баннеры. JPG, PNG или GIF. Максимальный размер файла 10 мб
										</div>
									</div>
									<div className="content__body-loader">
										{test.imgUrl
											? test.imgUrl.map(img =>
											<div className="img__prew"> <img src={img} alt={"Adv_avatar"}/></div>
											)
											: null}
										<div className="load__field">
											<FiImage />
											<p>Загрузите фотографии<span>*</span></p>
											<input
												type="file"
												multiple
												className="input__file"
												onChange={onHandleChangeFile}
												id="Photos"
											/>
										</div>
									</div>
									<div className="content">
										<h4>Об объекте</h4>
									</div>
									<div className="content">
										<label>Адрес квартиры<span>*</span></label>
										<input
											type="text"
											className="input__text"
											onChange={onTestUpdate}
											id="address"
											value={test.address}
										/>
									</div>

									<div className="left_input">
										<label>Цена<span>*</span></label>
										<input
											type="text"
											className="input__text"
											onChange={onTestUpdate}
											id="price"
											value={test.price}
										/>
									</div>

									<div className="centr_input">
										<label>Телефон<span>*</span></label>
										<input
											type="text"
											className="input__text"
											onChange={onTestUpdate}
											id="phone"
											value={test.phone}

										/>
									</div>

									<div className="right_input">
										<label>Количество комнат<span>*</span></label>
										<input
											type="text"
											className="input__text"
											onChange={onTestUpdate}
											id="rooms"
											value={test.rooms}
										/>
									</div>


									<div className="left_input">
										<label>Площадь<span>*</span></label>
										<input
											type="text"
											className="input__text"
											onChange={onTestUpdate}
											id="square"
											value={test.square}
										/>
									</div>

									<div className="centr_input">
										<label>Этаж<span>*</span></label>
										<input
											type="text"
											className="input__text"
											onChange={onTestUpdate}
											id="floor"
											value={test.floor}
										/>
									</div>


									<div className="content">
										<label>Описание<span>*</span></label>
										<textarea
											type="text"
											className="input__textarea"
											onChange={onTestUpdate}
											id="description"
											value={test.description}
										/>
									</div>

								</div>
						</form>
					</div>

					<div className="created__modal-bottom">
						<button type="button" className="close__button" onClick={() => {
							onVisiblePopup("modalUpdate");
						}}>Закрыть</button>

						{test.imgUrl !== null || test.address || test.phone  ?
						<button type="button" 
							className="success__button" 
							onClick={() => {
								const priceHistory =[...item.priceHistory, {date: item.date,price: item.price}]
								updateAdv(
									item.id,
									test.imgUrl,
									test.address,
									test.price,
									priceHistory,
									test.phone,
									test.rooms,
									test.square,
									test.floor,
									test.description,
                                    test.date,
									test.userId
								);
								onVisiblePopup("modalUpdate");
							}}>Сохранить
						</button> : 
						<button type="button" 
							className="disabled__button" 
						>Сохранить
						</button>
						}
					</div>
				</div>
			</div>
	);
};

export default AdvModalUpdate;